<template>
  <div v-loading="loadingModal" class="view-inventory-modal rounded overflow-hidden text-dark bg-white p-3.5">
    <!-- header -->
    <div class="view-inventory-modal__header flex items-center justify-between gap-3 mb-3.5">
      <div class="flex items-center gap-1">
        <svg width="16" height="16" fill="none">
          <use :xlink:href="`#globe`"></use>
        </svg>

        <h2 class="view-inventory-modal__title font-bold mb-0">Inventory</h2>
      </div>
      <button class="view-inventory-modal__close text-base" @click="close"><i class="icon-Close font-bold"></i></button>
    </div>
    <!-- end -->
    <!-- body -->
    <el-scrollbar>
      <div class="view-inventory-modal__body mb-3.5 max-h-[384px]">
        <p class="font-bold text-15px mb-0">{{ publisher?.name }}</p>
        <ul class="mb-3.5">
          <li
            v-for="(item, index) in publisher?.inventory"
            :key="index"
            class="flex items-center justify-between border-b border-grayLight p-1"
          >
            <a class="text-primary font-normal" :href="`//${item.domain}`" target="_blank">{{ item.domain }}</a>
            <svg width="24" height="25" fill="none">
              <use :xlink:href="`#eye`"></use>
            </svg>
          </li>
        </ul>
      </div>
    </el-scrollbar>
    <!-- end -->
    <!-- footer -->
    <div class="campaign-type-modal__footer-action flex justify-end items-center gap-2">
      <el-button class="font-semibold" @click="close">Close</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ViewInventory',
  props: {
    meta: {
      type: null,
      required: '',
    },
  },
  data() {
    return {
      loadingModal: false,
      inventoryList: [
        'www.avantaje.ro',
        'www.cariera.ejobs.ro',
        'www.ejobs.ro',
        'www.elle.ro',
        'www.imobiliare.ro',
        'www.imoradar24.ro',
        'www.jobradar24.ro',
      ],
    }
  },
  computed: {
    publishers() {
      return this.$store.getters['user/publishers']
    },
    publisher() {
      if (this.publishers.length === 0) {
        return false
      }
      return this.publishers?.find((item) => item.id === this.meta.publisher_id)
    },
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    ctaContinue() {
      this.close()
      this.$router.push({ name: 'social-boost-create', params: { type: this.type } })
    },
  },
}
</script>
